import { render, staticRenderFns } from "./index4.vue?vue&type=template&id=7fdf3af1&scoped=true"
import script from "./index4.vue?vue&type=script&lang=js"
export * from "./index4.vue?vue&type=script&lang=js"
import style0 from "./index4.vue?vue&type=style&index=0&id=7fdf3af1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fdf3af1",
  null
  
)

export default component.exports